'use client';

import { zodResolver } from '@hookform/resolvers/zod';
import { InputField } from '@pickleballinc/react-ui';
import { FormProvider, useForm } from 'react-hook-form';

import { ActionButtons } from '@/components/molecules';
import { ModalWrapper } from '@/components/organisms';
import { AddPlayerData, addPlayerSchema } from '@/entities';

interface AddPlayerFormProps {
	title: string;
	onClose: () => void;
	onSubmit: (data: AddPlayerData) => void;
}

export const AddPlayerForm = ({ title, onClose, onSubmit }: AddPlayerFormProps) => {
	const baseInputStyle = 'inputStyle w-full rounded-lg border border-gray-300 bg-white text-base font-normal !text-gray-500 shadow-xs';
	const baseLabelStyle = 'block text-sm font-medium leading-5 text-gray-700 mb-1.5';
	const baseStyle = 'px-3.5 py-2.5 bg-white text-gray-500 rounded-lg h-11';

	const form = useForm<AddPlayerData>({
		resolver: zodResolver(addPlayerSchema)
	});

	const { formState, register, handleSubmit } = form;

	return (
		<ModalWrapper title={title} onClose={onClose}>
			<FormProvider {...form}>
				<form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-9" autoComplete="off">
					<div className="flex flex-col gap-6">
						<InputField
							focusColor="orange"
							{...register('firstName')}
							label="First Name"
							hasError={!!formState.errors.firstName}
							hint={formState.errors.firstName?.message?.toString()}
							className={baseInputStyle}
							inputProps={{
								labelClassName: `${baseLabelStyle}`,
								className: `${baseStyle}`
							}}
						/>
						<InputField
							focusColor="orange"
							{...register('lastName')}
							label="Last Name"
							hasError={!!formState.errors.lastName}
							hint={formState.errors.lastName?.message?.toString()}
							className={baseInputStyle}
							inputProps={{
								labelClassName: `${baseLabelStyle}`,
								className: `${baseStyle}`
							}}
						/>
						<InputField
							focusColor="orange"
							{...register('email')}
							label="Email"
							hasError={!!formState.errors.email}
							hint={formState.errors.email?.message?.toString()}
							className={baseInputStyle}
							inputProps={{
								labelClassName: `${baseLabelStyle}`,
								className: `${baseStyle}`
							}}
						/>
						<InputField
							focusColor="orange"
							{...register('phoneNumber')}
							label="Phone"
							hasError={!!formState.errors.phoneNumber}
							hint={formState.errors.phoneNumber?.message?.toString()}
							className={baseInputStyle}
							inputProps={{
								labelClassName: `${baseLabelStyle}`,
								className: `${baseStyle}`
							}}
						/>
					</div>

					<ActionButtons
						onClose={onClose}
						submitButtonText="Save"
						closeButtonText="Cancel"
						submitButtonDisabled={form.formState.isSubmitting || !form.formState.isDirty}
					/>
				</form>
			</FormProvider>
		</ModalWrapper>
	);
};
